import LoaderSVG from '@public/icons/loader.svg';
import { GetStaticProps, InferGetStaticPropsType } from 'next';
import { useEffect, useRef } from 'react';
import type { Thing } from 'schema-dts';
import { getCommonPageProps } from '@/shared/api';
import { getPageDetail } from '@/shared/api/page-detail';
import DefaultLayout from '@/shared/components/layout/DefaultLayout';
import PageWelcome from '@/shared/components/sections/PageWelcome';
import JsonLd from '@/shared/components/shared/JsonLd/JsonLd';
import { CommonPageProps } from '@/shared/lib/types';
import { generateWebPageJsonLd } from '@/shared/lib/utils/page-json-ld';
import { scrollingPageToAnchor } from '@/shared/lib/utils/scrollingPageToAnchor';

const TourTnfPage = ({ tourSectionProps, breadcrumbs, meta }: InferGetStaticPropsType<typeof getStaticProps>) => {
    const ref = useRef(null);
    const SECTION_ID = 'tour';

    useEffect(() => {
        scrollingPageToAnchor('center');
    }, []);

    return (
        <DefaultLayout ref={ref}>
            <PageWelcome breadcrumbs={breadcrumbs} title={tourSectionProps.title} />
            <div className="tour__section" id={SECTION_ID}>
                <div className="tour__wrapper wrapper">
                    <div className="tour-frame-wrapper">
                        <div className="tour-frame">
                            <iframe
                                src={tourSectionProps.href}
                                width="100%"
                                height="100%"
                                loading="lazy"
                                title={tourSectionProps.title}
                            ></iframe>
                        </div>
                        <div className="tour-frame-loader">
                            <LoaderSVG />
                        </div>
                    </div>
                </div>
            </div>
            <JsonLd<Thing>
                inBody
                scriptKey="ld-json-tour-tnf"
                data={generateWebPageJsonLd({
                    name: tourSectionProps.title,
                    description: meta.description,
                    pagePath: '/tour-tnf/',
                    breadcrumbs,
                })}
            />
        </DefaultLayout>
    );
};

export default TourTnfPage;

export type TourTnfPageProps = CommonPageProps & {
    tourSectionProps: TourSectionProps;
};

export type TourSectionProps = {
    title: string;
    href: string;
};

export const getStaticProps: GetStaticProps<TourTnfPageProps> = async () => {
    const pageResponse = await getPageDetail({ params: { slug: 'main' } });

    const [commonPageProps] = await Promise.all([getCommonPageProps()]);

    return {
        props: {
            ...commonPageProps,
            bodyClass: 'tour-page',
            meta: {
                ...commonPageProps.meta,
                ...(pageResponse.data?.meta ?? []),
            },
            breadcrumbs: [
                { text: 'TNF', href: '/' },
                { text: 'tour-TNF', href: '/tour-tnf/' },
            ],
            tourSectionProps: {
                title: 'Тур по TNF 2024',
                href: 'https://kuula.co/share/h7t21/collection/7ZPQg?logo=1&info=1&fs=1&vr=0&sd=1&thumbs=1',
            },
        } satisfies TourTnfPageProps,
        revalidate: 60,
    };
};
